import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";

export function InfoModal(props: {
  show: boolean;
  body: string | JSX.Element;
  callback: () => void;
}) {
  const [show, setShow] = useState(props.show);
  const handleClose = useCallback(() => {
    setShow(false);
    props.callback();
  }, []);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <Modal id="modal" show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title id="modalTitle">Information</Modal.Title>
      </Modal.Header>
      <Modal.Body id="modalBody">{props.body}</Modal.Body>
      <Modal.Footer>
        <button className="rsi-button is-primary" id="modalOkButton" onClick={handleClose}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export function ErrorModal(props: {
  show: boolean;
  body: string | JSX.Element;
  callback: () => void;
}) {
  const [show, setShow] = useState(props.show);
  const handleClose = () => {
    setShow(false);
    props.callback();
  };
  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <Modal id="modal" show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title id="modalTitle">Error</Modal.Title>
      </Modal.Header>
      <Modal.Body id="modalBody">{props.body}</Modal.Body>
      <Modal.Footer>
        <button className="rsi-button is-primary" id="modalOkButton" onClick={handleClose}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
}
